webpackJsonp([28],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__auth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(200);
/* unused harmony reexport global */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__resource__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__password__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_3__password__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__phonevalidate__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__phonevalidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__architectureManagement__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__architectureManagement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deptDetail__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__deptDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__positionDetail__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__positionDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__staff__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__staff__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__functionalManagement__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__functionalManagement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configFuntional__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__configFuntional__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__organizationalManagement__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__organizationalManagement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__authWorkbench__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__authWorkbench__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__authConfig__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__authConfig__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__resourceDevSync__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_14__resourceDevSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__resourceDevSyncLog__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_15__resourceDevSyncLog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__authQuery__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__authQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__authApply__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__authApply__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mineApply__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_18__mineApply__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__operationLog__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_19__operationLog__["a"]; });









































/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debounce__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__debounce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deptListToCascader__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__deptListToCascader__["a"]; });







/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keepAlives; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu__ = __webpack_require__(168);








// Lazy load:
// https://router.vuejs.org/zh-cn/advanced/lazy-loading.html

var Home = function Home() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 496));
};
var User = function User() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 511));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 506));
};
var Guide = function Guide() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 504));
};
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 507));
};
var Password = function Password() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 509));
};
var ChangePwd = function ChangePwd() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 508));
};
var PhoneValidate = function PhoneValidate() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 510));
};
var Health = function Health() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 505));
};

var authRouter = [];
var keepAlives = []; //缓存组件列表

Object.keys(__WEBPACK_IMPORTED_MODULE_5__menu__["a" /* default */]).forEach(function (module) {
  return Object.keys(__WEBPACK_IMPORTED_MODULE_5__menu__["a" /* default */][module].pages).forEach(function (page) {
    var _menu$module$pages$pa = __WEBPACK_IMPORTED_MODULE_5__menu__["a" /* default */][module].pages[page],
        label = _menu$module$pages$pa.label,
        path = _menu$module$pages$pa.path,
        component = _menu$module$pages$pa.component,
        keepAlive = _menu$module$pages$pa.keepAlive;


    if (keepAlive) {
      keepAlives.push(page);
    }

    authRouter.push({
      name: page,
      path: path,
      component: component,
      meta: {
        requiresAuth: true,
        docTitle: '\u6743\u9650\u63A7\u5236\u7CFB\u7EDF-' + label
      }
    });
  });
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/password',
    name: 'password',
    component: Password,
    meta: {
      docTitle: '重置密码'
    }
  }, {
    path: '/changepwd',
    name: 'changePwd',
    component: ChangePwd,
    meta: {
      docTitle: '修改密码'
    }
  }, {
    path: '/phonevalidate',
    name: 'phonevalidate',
    component: PhoneValidate,
    meta: {
      docTitle: '兼职账号安全验证'
    }
  }, {
    path: '/health',
    name: 'health',
    component: Health,
    meta: {
      docTitle: '健康检测'
    }
  }, {
    path: '/user',
    component: User,
    children: [{
      path: '',
      redirect: '/user/home'
    }, {
      name: 'home',
      path: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
        docTitle: '权限控制系统-主页'
      }
    }].concat(authRouter)
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      docTitle: '欢迎登录综合管理平台'
    }
  }, {
    path: '/guide',
    name: 'guide',
    component: Guide,
    meta: {
      requiresAuth: true,
      docTitle: '综合管理平台导航'
    }
  }, {
    path: '*',
    name: 'not-found',
    component: NotFound,
    meta: {
      docTitle: '404'
    }
  }]
});

function checkRouter(to, from, next) {
  if (to.name === 'guide' || to.name === 'home' || __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.validPage.indexOf(to.name) > -1) {
    return next();
  }

  if (from.name) {
    __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default()({
      message: '您暂无权限进入该页面',
      duration: 3,
      type: 'error'
    });
    return next(false);
  }
  __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default()({
    message: '您暂无权限进入该页面, 已返回系统主页',
    duration: 3,
    type: 'error'
  });
  return next({
    name: 'home'
  });
}

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token');
    var userId = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('userId');
    var userName = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('userName');
    if (token && userId && userName) {
      if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.userName === 'admin' || to.name === 'guide') {
        return next();
      }
      if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.validMenu.loaded && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.systems.loaded) {
        return checkRouter(to, from, next);
      }

      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('auth/LOAD_CITYLIST', {
        frontCode: 'NOT',
        params: {
          sysCode: 'izk-authservice'
        }
      }).then(function () {
        var loads = [];
        if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.validMenu.loaded) {
          loads.push(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('auth/LOAD_MENULIST', {
            frontCode: 'NOT'
          }));
        }
        if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.auth.systems.loaded) {
          loads.push(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('auth/LOAD_SYSTEMS', {
            frontCode: 'NOT'
          }));
        }
        return Promise.all(loads).then(function () {
          return checkRouter(to, from, next);
        }).catch(function () {
          return false;
        });
      });
    } else {
      return next({
        name: 'login',
        query: { target: encodeURIComponent(window.location.href) }
      });
    }
  } else {
    return next();
  }
});

router.afterEach(function (route) {
  // 改变Title:
  document.title = route.matched[route.matched.length - 1].meta.docTitle;
});

/* harmony default export */ __webpack_exports__["a"] = (router);


/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(76);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]); // use vuex-router-sync.

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Lazy load:
// https://router.vuejs.org/zh-cn/advanced/lazy-loading.html

var Resource = function Resource() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 500));
};
var ResourceDev = function ResourceDev() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 501));
};
var OperationLog = function OperationLog() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 499));
};

var ArchitectureManagement = function ArchitectureManagement() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 490));
};
var DeptDetail = function DeptDetail() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 491));
};
var PositionDetail = function PositionDetail() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 492));
};
var ResourceDevSync = function ResourceDevSync() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 502));
};
var ResourceDevSyncLog = function ResourceDevSyncLog() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 503));
};

// 员工管理
var Staff = function Staff() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 497));
};
var StaffOperation = function StaffOperation() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 498));
};
var FunctionalManagement = function FunctionalManagement() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 494));
};
var ConfigFunctional = function ConfigFunctional() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 493));
};
var OrganizationalManagement = function OrganizationalManagement() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 495));
};
var AuthWorkbench = function AuthWorkbench() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 489));
};
var AuthConfig = function AuthConfig() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 488));
};

//权限申请
var AuthQuery = function AuthQuery() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 486));
};
var AuthApply = function AuthApply() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 485));
};
var MyApply = function MyApply() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 487));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  'm-system': {
    icon: 'izk-nav-system',
    label: '系统管理',
    pages: {
      'p-resource': {
        label: '资源排序管理',
        store: 'resource',
        path: 'system/resource-manage',
        component: Resource
      },
      'p-resource_dev': {
        label: '菜单权限管理',
        store: 'resourceDev',
        path: 'system/resource-manage-dev',
        component: ResourceDev
      },
      'p-operation_log': {
        label: '用户操作日志',
        store: 'operationLog',
        path: 'system/operation-log-manage',
        component: OperationLog
      },
      'p-resourceDev_sync': {
        label: '批量同步资源点',
        store: 'resourceDevSync',
        path: 'system/resource-dev-sync',
        component: ResourceDevSync,
        hidden: true
      },
      'p-resourceDev_syncLog': {
        label: '同步资源点日志',
        store: 'resourceDevSyncLog',
        path: 'system/resource-dev-syncLog',
        component: ResourceDevSyncLog,
        hidden: true
      }
    }
  },
  'm-basicConfig': {
    icon: 'izk-nav-basicConfig',
    label: '基础信息配置',
    pages: {
      'p-architectureManagement': {
        label: '组织架构管理',
        store: 'architectureManagement',
        path: 'basicConfig/architecture-management',
        component: ArchitectureManagement,
        keepAlive: true
      },
      'p-deptDetail': {
        label: '部门详情',
        store: 'deptDetail',
        path: 'basicConfig/architecture-management/dept-detail',
        component: DeptDetail,
        hidden: true
      },
      'p-positionDetail': {
        label: '职位详情',
        store: 'positionDetail',
        path: 'basicConfig/architecture-management/position-detail',
        component: PositionDetail,
        hidden: true
      },
      'p-functionalManagement': {
        label: '职能包管理',
        store: 'functionalManagement',
        path: 'basicConfig/functional-management',
        component: FunctionalManagement,
        keepAlive: true
      },
      'p-configFuntional': {
        label: '配置职能包',
        store: 'configFuntional',
        path: 'basicConfig/functional-management/config-functional',
        component: ConfigFunctional,
        hidden: true
      },
      'p-organizationalManagement': {
        label: '组织管理',
        store: 'organizationalManagement',
        path: 'basicConfig/organizational-management',
        component: OrganizationalManagement
      }
    }
  },
  'm-staff': {
    icon: 'izk-nav-staff',
    label: '员工管理',
    pages: {
      'p-staff_list': {
        label: '员工列表',
        store: 'staffList',
        path: 'staff/list',
        component: Staff
      },
      'p-staff_operation': {
        label: '新增员工',
        store: 'staffOperation',
        path: 'staff/operation',
        component: StaffOperation,
        hidden: true
      }
    }
  },
  'm-authConfig': {
    icon: 'izk-nav-authConfig',
    label: '用户权限配置',
    pages: {
      'p-authWorkbench': {
        label: '权限处理工作台',
        store: 'authWorkbench',
        path: 'authConfig/auth-workbench',
        component: AuthWorkbench,
        keepAlive: true
      },
      'p-authConfig': {
        label: '权限配置',
        store: 'authConfig',
        path: 'authConfig/auth-config',
        component: AuthConfig,
        hidden: true
      }
    }
  },
  'm-authApply': {
    icon: 'izk-nav-basicConfig',
    label: '权限申请',
    pages: {
      'p-authQuery': {
        label: '权限查询',
        store: 'authQuery',
        path: 'authApply/auth-query',
        component: AuthQuery,
        keepAlive: true
      },
      'p-authApply': {
        label: '权限申请',
        store: 'authApply',
        path: 'authApply/auth-apply',
        component: AuthApply
      },
      'p-myApply': {
        label: '我的申请',
        store: 'myApply',
        path: 'authApply/my-apply',
        component: MyApply
      }
    }
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getTypeList: '/auth/dept/list', //获取部门类型
    getDepartmentList: '/auth/token/condition/department', //获取部门机构列表
    addDepart: '/auth/dept/addDept', //新增部门、部门类型
    updateDepart: '/auth/dept/updateDept', //编辑部门、部门类型
    delDepart: '/auth/dept/deleteDept', //删除部门、部门类型
    getPosIdentList: '/auth/rankMark/pageMark', //获取职级、标识列表
    getNewPosIdentItem: '/auth/rankMark/addRankMark', //新增时获取一项新的职级、标识
    addPosition: '/auth/rankMark/updateRank', //新增职级-保存
    addIdentifiy: '/auth/rankMark/bindingMark', //新增标识-保存
    unbindIdentify: '/auth/rankMark/deleteMarkPosition', //标识-解绑
    getPosDeptSearchResult: '/auth/token/condition/deptOrPosition' //职位或部门查询
});

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  login: '/sso/userlogin',
  refreshToken: '/sso/refreshtoken',
  code: '/sso/logincode/prepare',
  logout: '/sso/userlogout',
  checktoken: '/sso/checktoken',
  checkURL: '/sso/checkURL',
  loadRes: '/sso/sysres',
  loadSystems: '/sso/usersystems',
  modifyPwd: '/sso/modifypwd',
  getQrCode: '/sso/getqrcode',
  getQrCodeStatus: '/sso/queryqrcodestatus',
  loadCitylist: '/sso/sysuser/citylist'
});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  saveAuthority: '/auth/authority/request/save',
  infoAuthority: '/auth/authority/request/info',
  infoAuthoritUncheck: '/auth/authority/request/api/info'
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    authConfigDetail: '/auth/userPermission/getDetail', //用户权限配置--获取权限详情
    authConfigDelete: '/auth/userPermission/deletePermission', //用户权限配置--权限删除
    authConfigBind: '/auth/userPermission/permissionChangeNotify', //用户权限配置--发送钉钉通知
    updateAuthConfig: '/auth/userPermission/updatePermission', //用户权限配置--更新单独的权限
    updateUseBasicDetail: '/auth/userPermission/updateUseBasicDetail' //用户权限配置--保存

});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  queryPermission: '/auth/userPermission/frontDeskQueryPermission',
  queryUserList: '/auth/user/frontDeskQueryUser'
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deletePermission: '/auth/userPermission/deletePermission', //删除权限
  authValidity: '/auth/user/authValidity', //权限停用启用
  getPhoneEmail: '/auth/user/get-user-phone-and-email' //手机号脱敏
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getResourceListByFuncId: '/auth/function/functionResource', //根据职能包获取资源列表
    bindFunctionalResource: '/auth/function/functionResourceBinding' //根据职能包获取资源列表
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getDepartmentList: '/auth/dept/pageDept' //表格查询获取部门列表
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getOrgTypeFunTypeStatus: '/auth/function/selected', //获取组织部门类型信息
    getSystemList: '/auth/res/system/all', //获取系统列表
    getFunList: '/auth/function/list', //获取职能包列表
    stopFunctional: '/auth/function/stopUsing', //职能包停用
    startFunctional: '/auth/function/reusing', //职能包启用
    deletFunctional: '/auth/function/delete', //职能包删除
    addFun: '/auth/function/addFunction', //职能包-新增
    updateFun: '/auth/function/updateFunction', //职能包-编辑
    getFunDetail: '/auth/function/detail' //职能包-详情
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  queryAuthority: '/auth/authority/request/query'
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getOperateLog: '/auth/operate/operateList',
  getOperateLogReport: '/auth/operate/exportOperateExcel'
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getOrganizationList: '/auth/organization/organizationList', //获取组织列表
    deleteOrg: '/auth/organization/deleteOrganization', //组织删除
    addOrg: '/auth/organization/addOrganization', //组织新增
    getCityList: '/auth/token/condition/cityCodeList', //获取城市
    updateOrg: '/auth/organization/updateOrganization' //组织新增

});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getcode: '/sso/getSms',
  changepwd: '/sso/resetPwd'
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // getauthcode: '/sso/sms',
  // checkcode: '/sso/verifyCode',
  getauthcode: '/sso/getAuthCode',
  checkcode: '/sso/verifyAuthCodeAndRecord'
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getPositionList: '/auth/position/list', //表格查询获取部门列表
    getStatusMarkFunctional: '/auth/position/selected/satisfied', //获取职位状态，标识，职能包
    getPosTypeRank: '/auth/position/selected/rankAndType', //获取职级、职位类型
    deletPosition: '/auth/position/deletePosition', //职位删除
    updatePosition: '/auth/position/updatePosition', //职位编辑
    addPosition: '/auth/position/addPosition', //职位新增
    startPosition: '/auth/position/reusing', //职位启用
    stopPosition: '/auth/position/stopUsing', //职位停用
    getPositionDetail: '/auth/position/getDetail', //获取职位详情
    getFunBindList: '/auth/position/getFunctionsByPositionId', //获取职能绑定列表
    getFunListByDept: '/auth/position/function/deptId/systemId/types', //获取部门下的职能包
    bindFunctional: '/auth/position/functional/bind', //职能包绑定
    deleteFunBind: '/auth/position/function/delete', //职能包绑定删除
    getUserList: '/auth/position/user/list', //获取用户列表
    getOrgListByOrgType: '/auth/organization/orgNames', //根据组织类型获取组织
    getDeptByOrgType: '/auth/token/condition/positionDepartment', //根据组织类型获取部门
    getPositionByDept: '/auth/position/dept/list' //根据部门机构获取职位
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  query: '/auth/res/query', // 获取(全部)某个系统的资源列表信息
  urlQuery: '/auth/res/devurl/query', // 开发配置url查询
  create: '/auth/res/create', // 新增资源
  update: '/auth/res/update', // 编辑资源
  validRes: '/auth/res/valid/update', // 停用、启用某个资源
  orderUpdate: '/auth/res/order/update', // 资源排序码修改
  devUpdate: '/auth/res/dev/update', // 开发配置接口
  delete: '/auth/res/delete', // 删除资源
  queryAbility: '/auth/res/ability/query', // 获取功能
  updateAbility: '/auth/res/ability/update' // 更改功能
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  query: '/auth/res/query', // 获取(全部)某个系统的资源列表信息
  syncVerifyResource: '/auth/res/syncVerifyResource', // 同步资源检测
  syncResource: '/auth/res/syncResource' // 同步资源
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  query: '/auth/res/syncLog' // 获取日志数据
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // 员工列表页
  queryStaffList: '/auth/user/pageList', // 获取员工列表 
  querydeptAndOrg: '/auth/token/condition/deptAndOrg', // 获取组织部门数据
  queryFundOwner: '/auth/token/condition/orgAndSchool', // 查询款项归属

  // 员工新增、编辑页
  queryInfoByUId: '/auth/user/query', // 根据工号查询个人信息
  queryVirtualId: '/auth/user/queryCode', // 根据员工类型获取 虚拟员工id
  addStaff: '/auth/user/create', // 新增员工接口
  changeStaffStatus: '/auth/user/userValidity', // 切换员工二次入职和离职
  deleteUser: '/auth/user/deleteUser', // 根据钉钉号删除用户
  orgInfoUpdate: '/auth/user/infoUpdate', // 新增员工-编辑部门组织
  refreshPassword: '/auth/user/refreshPassword', // 编辑员工 重置密码
  sendDingTalk: '/auth/user/modifyUserInfoSendDingTalk'
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_TYPELIST = 'architectureManagement/GET_TYPELIST'; //获取组织类型
var GET_DEPARTMENTLIST = 'architectureManagement/GET_DEPARTMENTLIST'; //获取部门机构列表
var ADD_DEPART = 'architectureManagement/ADD_DEPART'; //新增部门、组织类型
var UPDATE_DEPART = 'architectureManagement/UPDATE_DEPART'; //编辑部门、组织类型
var DElETE_DEPART = 'architectureManagement/DElETE_DEPART'; //删除部门、组织类型

var GET_POSIDENTLIST = 'architectureManagement/GET_POSIDENTLIST'; //职级、标识列表
var GET_NEWPOSIDENTITEM = 'architectureManagement/GET_NEWPOSIDENTITEM'; //新增时获取一项新的职级、标识
var ADD_POSITION = 'architectureManagement/ADD_POSITION'; //职级-保存
var ADD_IDENTIFY = 'architectureManagement/ADD_IDENTIFY'; //新增标识-保存
var UNBIND_IDENTIFY = 'architectureManagement/UNBIND_IDENTIFY'; //标识解绑

var UPDATE_STORE_POSITIONLIST = 'architectureManagement/UPDATE_STORE_POSITIONLIST'; //更新职级列表store内的positionList
var UPDATE_STORE_IDENTFIYLIST = 'architectureManagement/UPDATE_STORE_IDENTFIYLIST'; //更新标识列表store内的positionList
var DELETE_STORE_POSITION = 'architectureManagement/DELETE_STORE_POSITION'; //删除职级列表store内的position
var DELETE_STORE_IDENTIFY = 'architectureManagement/DELETE_STORE_IDENTIFY'; //删除职级列表store内的identify


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        typeList: [],
        positionList: [],
        identifiyList: [],
        positionByDept: [],
        deptList: [],
        deptListByDept: []
    },
    actions: (_actions = {}, _defineProperty(_actions, GET_TYPELIST, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_TYPELIST;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].getTypeList, frontCode);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), _defineProperty(_actions, GET_DEPARTMENTLIST, function (_ref3) {
        var _this2 = this;

        var commit = _ref3.commit;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$params = _ref4.params,
            params = _ref4$params === undefined ? {} : _ref4$params,
            _ref4$frontCode = _ref4.frontCode,
            frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.t0 = commit;
                            _context2.t1 = GET_DEPARTMENTLIST;
                            _context2.t2 = params;
                            _context2.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].getDepartmentList, { params: params }, frontCode, false);

                        case 5:
                            _context2.t3 = _context2.sent;
                            _context2.t4 = {
                                params: _context2.t2,
                                data: _context2.t3
                            };
                            (0, _context2.t0)(_context2.t1, _context2.t4);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _defineProperty(_actions, ADD_DEPART, function (_ref5) {
        var _this3 = this;

        var commit = _ref5.commit;

        var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref6$data = _ref6.data,
            data = _ref6$data === undefined ? {} : _ref6$data,
            _ref6$frontCode = _ref6.frontCode,
            frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.t0 = commit;
                            _context3.t1 = ADD_DEPART;
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].addDepart, { data: data }, frontCode, true, true);

                        case 4:
                            _context3.t2 = _context3.sent;
                            (0, _context3.t0)(_context3.t1, _context3.t2);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }), _defineProperty(_actions, UPDATE_DEPART, function (_ref7) {
        var _this4 = this;

        var commit = _ref7.commit;

        var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref8$data = _ref8.data,
            data = _ref8$data === undefined ? {} : _ref8$data,
            _ref8$frontCode = _ref8.frontCode,
            frontCode = _ref8$frontCode === undefined ? '' : _ref8$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.t0 = commit;
                            _context4.t1 = UPDATE_DEPART;
                            _context4.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].updateDepart, { data: data }, frontCode, false, true);

                        case 4:
                            _context4.t2 = _context4.sent;
                            (0, _context4.t0)(_context4.t1, _context4.t2);

                        case 6:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    }), _defineProperty(_actions, DElETE_DEPART, function (_ref9) {
        var _this5 = this;

        var commit = _ref9.commit;

        var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref10$data = _ref10.data,
            data = _ref10$data === undefined ? {} : _ref10$data,
            _ref10$frontCode = _ref10.frontCode,
            frontCode = _ref10$frontCode === undefined ? '' : _ref10$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.t0 = commit;
                            _context5.t1 = DElETE_DEPART;
                            _context5.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].delDepart, { data: data }, frontCode);

                        case 4:
                            _context5.t2 = _context5.sent;
                            (0, _context5.t0)(_context5.t1, _context5.t2);

                        case 6:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }), _defineProperty(_actions, GET_POSIDENTLIST, function (_ref11) {
        var _this6 = this;

        var commit = _ref11.commit;

        var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref12$params = _ref12.params,
            params = _ref12$params === undefined ? {} : _ref12$params,
            _ref12$frontCode = _ref12.frontCode,
            frontCode = _ref12$frontCode === undefined ? '' : _ref12$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.t0 = commit;
                            _context6.t1 = GET_POSIDENTLIST;
                            _context6.t2 = params;
                            _context6.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].getPosIdentList, { params: params }, frontCode, false);

                        case 5:
                            _context6.t3 = _context6.sent;
                            _context6.t4 = {
                                params: _context6.t2,
                                data: _context6.t3
                            };
                            (0, _context6.t0)(_context6.t1, _context6.t4);

                        case 8:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }), _defineProperty(_actions, GET_NEWPOSIDENTITEM, function (_ref13) {
        var _this7 = this;

        var commit = _ref13.commit;

        var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref14$data = _ref14.data,
            data = _ref14$data === undefined ? {} : _ref14$data,
            _ref14$frontCode = _ref14.frontCode,
            frontCode = _ref14$frontCode === undefined ? '' : _ref14$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.t0 = commit;
                            _context7.t1 = GET_NEWPOSIDENTITEM;
                            _context7.t2 = data;
                            _context7.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].getNewPosIdentItem, { data: data }, frontCode, false);

                        case 5:
                            _context7.t3 = _context7.sent;
                            _context7.t4 = {
                                params: _context7.t2,
                                data: _context7.t3
                            };
                            (0, _context7.t0)(_context7.t1, _context7.t4);

                        case 8:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    }), _defineProperty(_actions, ADD_POSITION, function (_ref15) {
        var _this8 = this;

        var commit = _ref15.commit;

        var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref16$data = _ref16.data,
            data = _ref16$data === undefined ? {} : _ref16$data,
            _ref16$frontCode = _ref16.frontCode,
            frontCode = _ref16$frontCode === undefined ? '' : _ref16$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.t0 = commit;
                            _context8.t1 = ADD_POSITION;
                            _context8.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].addPosition, { data: data }, frontCode, false);

                        case 4:
                            _context8.t2 = _context8.sent;
                            (0, _context8.t0)(_context8.t1, _context8.t2);

                        case 6:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    }), _defineProperty(_actions, ADD_IDENTIFY, function (_ref17) {
        var _this9 = this;

        var commit = _ref17.commit;

        var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref18$data = _ref18.data,
            data = _ref18$data === undefined ? {} : _ref18$data,
            _ref18$frontCode = _ref18.frontCode,
            frontCode = _ref18$frontCode === undefined ? '' : _ref18$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.t0 = commit;
                            _context9.t1 = ADD_IDENTIFY;
                            _context9.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].addIdentifiy, { data: data }, frontCode, false);

                        case 4:
                            _context9.t2 = _context9.sent;
                            (0, _context9.t0)(_context9.t1, _context9.t2);

                        case 6:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    }), _defineProperty(_actions, UNBIND_IDENTIFY, function (_ref19) {
        var _this10 = this;

        var commit = _ref19.commit;

        var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref20$data = _ref20.data,
            data = _ref20$data === undefined ? {} : _ref20$data,
            _ref20$frontCode = _ref20.frontCode,
            frontCode = _ref20$frontCode === undefined ? '' : _ref20$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.t0 = commit;
                            _context10.t1 = UNBIND_IDENTIFY;
                            _context10.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* architectureManagement */].unbindIdentify, { data: data }, frontCode, false);

                        case 4:
                            _context10.t2 = _context10.sent;
                            (0, _context10.t0)(_context10.t1, _context10.t2);

                        case 6:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    }), _defineProperty(_actions, UPDATE_STORE_POSITIONLIST, function (_ref21) {
        var _this11 = this;

        var commit = _ref21.commit;

        var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref22$data = _ref22.data,
            data = _ref22$data === undefined ? {} : _ref22$data;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            commit(UPDATE_STORE_POSITIONLIST, data);

                        case 1:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    }), _defineProperty(_actions, UPDATE_STORE_IDENTFIYLIST, function (_ref23) {
        var _this12 = this;

        var commit = _ref23.commit;

        var _ref24 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref24$data = _ref24.data,
            data = _ref24$data === undefined ? {} : _ref24$data;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            commit(UPDATE_STORE_IDENTFIYLIST, data);

                        case 1:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    }), _defineProperty(_actions, DELETE_STORE_POSITION, function (_ref25) {
        var _this13 = this;

        var commit = _ref25.commit;

        var _ref26 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref26$data = _ref26.data,
            data = _ref26$data === undefined ? {} : _ref26$data;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            commit(DELETE_STORE_POSITION, data);

                        case 1:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13);
        }))();
    }), _defineProperty(_actions, DELETE_STORE_IDENTIFY, function (_ref27) {
        var _this14 = this;

        var commit = _ref27.commit;

        var _ref28 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref28$data = _ref28.data,
            data = _ref28$data === undefined ? {} : _ref28$data;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            commit(DELETE_STORE_IDENTIFY, data);

                        case 1:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }))();
    }), _actions),
    mutations: (_mutations = {}, _defineProperty(_mutations, GET_TYPELIST, function (state, data) {
        state.typeList = data;
    }), _defineProperty(_mutations, GET_DEPARTMENTLIST, function (state, payload) {
        if (payload.params.deptId) {
            state.deptListByDept = payload.data;
        } else {
            state.deptList = payload.data;
        }
    }), _defineProperty(_mutations, ADD_DEPART, function (state, data) {}), _defineProperty(_mutations, UPDATE_DEPART, function (state, data) {}), _defineProperty(_mutations, DElETE_DEPART, function (state, data) {}), _defineProperty(_mutations, GET_POSIDENTLIST, function (state, payload) {
        if (payload.params.types == 1) {
            //职级
            state.positionList = payload.data.content ? payload.data.content : [];
        } else if (payload.params.types == 2) {
            //标识
            state.identifiyList = payload.data.content ? payload.data.content : [];
        }
    }), _defineProperty(_mutations, GET_NEWPOSIDENTITEM, function (state, payload) {
        if (payload.params.types == 1) {
            //职级
            state.positionList.push(payload.data);
        } else if (payload.params.types == 2) {
            //标识
            state.identifiyList.push(payload.data);
        }
    }), _defineProperty(_mutations, ADD_POSITION, function (state, data) {}), _defineProperty(_mutations, ADD_IDENTIFY, function (state, data) {}), _defineProperty(_mutations, UNBIND_IDENTIFY, function (state, data) {}), _defineProperty(_mutations, UPDATE_STORE_POSITIONLIST, function (state, data) {
        state.positionList = JSON.parse(JSON.stringify(data.list));
    }), _defineProperty(_mutations, UPDATE_STORE_IDENTFIYLIST, function (state, data) {
        state.identifiyList = JSON.parse(JSON.stringify(data.list));
    }), _defineProperty(_mutations, DELETE_STORE_POSITION, function (state, data) {
        state.positionList.splice(data.index, 1);
    }), _defineProperty(_mutations, DELETE_STORE_IDENTIFY, function (state, data) {
        state.identifiyList.splice(data.index, 1);
    }), _mutations)
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _actions, _mutations;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var LOGIN = 'auth/LOGIN';
var REFRESH_TOKEN = 'auth/REFRESH_TOKEN';
var LOAD_CODE = 'auth/LOAD_CODE';
var LOGOUT = 'auth/LOGOUT';
var LOAD_SYSTEMS = 'auth/LOAD_SYSTEMS';
var LOAD_MENULIST = 'auth/LOAD_MENULIST';
var MODIFY_PWD = 'auth/MODIFY_PWD';
var QRLOGIN = 'auth/QRLOGIN';
var QRLOGINSTATUS = "auth/QRSTATUS";
var LOAD_CITYLIST = 'auth/LOAD_CITYLIST';
var UPDATE_CITYNAME = 'auth/UPDATE_CITYNAME';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    token: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token') || '',
    userId: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userId') || '',
    userName: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userName') || '',
    codeUrl: '',
    codeKey: '',
    systems: {
      loaded: false,
      value: []
    },
    validMenu: {
      loaded: false,
      value: []
    },
    validMoudle: [],
    validPage: [],
    validBtns: '',
    cityList: [],
    curCityName: ''
  },
  actions: (_actions = {}, _defineProperty(_actions, QRLOGIN, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === undefined ? {} : _ref2$headers;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].getQrCode, { data: data, headers: headers }, frontCode, false, true, false);

            case 2:
              result = _context.sent;

              commit(LOGIN, result);
              return _context.abrupt('return', result);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_actions, QRLOGINSTATUS, function (_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$data = _ref4.data,
        data = _ref4$data === undefined ? {} : _ref4$data,
        _ref4$frontCode = _ref4.frontCode,
        frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode,
        _ref4$headers = _ref4.headers,
        headers = _ref4$headers === undefined ? {} : _ref4$headers;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].getQrCodeStatus, { data: data, headers: headers }, frontCode, false, true, false);

            case 2:
              result = _context2.sent;

              commit(LOGIN, result);
              return _context2.abrupt('return', result);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _defineProperty(_actions, LOGIN, function (_ref5) {
    var _this3 = this;

    var commit = _ref5.commit;

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$data = _ref6.data,
        data = _ref6$data === undefined ? {} : _ref6$data,
        _ref6$frontCode = _ref6.frontCode,
        frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode,
        _ref6$headers = _ref6.headers,
        headers = _ref6$headers === undefined ? {} : _ref6$headers;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].login, { data: data, headers: headers }, frontCode, false, true, false);

            case 2:
              result = _context3.sent;

              commit(LOGIN, result);
              return _context3.abrupt('return', result);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _defineProperty(_actions, LOAD_CODE, function (_ref7) {
    var _this4 = this;

    var commit = _ref7.commit;

    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref8$data = _ref8.data,
        data = _ref8$data === undefined ? {} : _ref8$data,
        _ref8$frontCode = _ref8.frontCode,
        frontCode = _ref8$frontCode === undefined ? '' : _ref8$frontCode,
        _ref8$header = _ref8.header,
        header = _ref8$header === undefined ? {} : _ref8$header;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var result;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].code, { data: _extends({
                  secretkey: 'gnNSqzr6551qyiPB3xoX81z0QhFnjUcE'
                }, data)
              }, frontCode, false, true, false);

            case 2:
              result = _context4.sent;

              commit(LOAD_CODE, result);
              return _context4.abrupt('return', result);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }), _defineProperty(_actions, REFRESH_TOKEN, function (_ref9) {
    var _this5 = this;

    var commit = _ref9.commit;

    var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref10$data = _ref10.data,
        data = _ref10$data === undefined ? {} : _ref10$data,
        _ref10$frontCode = _ref10.frontCode,
        frontCode = _ref10$frontCode === undefined ? '' : _ref10$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = commit;
              _context5.t1 = REFRESH_TOKEN;
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].refreshToken, { data: data }, frontCode);

            case 4:
              _context5.t2 = _context5.sent;
              (0, _context5.t0)(_context5.t1, _context5.t2);

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }), _defineProperty(_actions, LOGOUT, function (_ref11) {
    var _this6 = this;

    var commit = _ref11.commit;

    var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref12$params = _ref12.params,
        params = _ref12$params === undefined ? {} : _ref12$params,
        _ref12$frontCode = _ref12.frontCode,
        frontCode = _ref12$frontCode === undefined ? '' : _ref12$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].logout, { params: params }, frontCode);

            case 2:
              commit(LOGOUT);
              commit('root/RESET');

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }), _defineProperty(_actions, LOAD_MENULIST, function (_ref13) {
    var _this7 = this;

    var commit = _ref13.commit;

    var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref14$params = _ref14.params,
        params = _ref14$params === undefined ? {} : _ref14$params,
        _ref14$frontCode = _ref14.frontCode,
        frontCode = _ref14$frontCode === undefined ? '' : _ref14$frontCode,
        _ref14$globalLoading = _ref14.globalLoading,
        globalLoading = _ref14$globalLoading === undefined ? true : _ref14$globalLoading;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = commit;
              _context7.t1 = LOAD_MENULIST;
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].loadRes + '/izk-authservice/menu', { params: params }, frontCode, globalLoading);

            case 4:
              _context7.t2 = _context7.sent;
              (0, _context7.t0)(_context7.t1, _context7.t2);

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }), _defineProperty(_actions, LOAD_SYSTEMS, function (_ref15) {
    var _this8 = this;

    var commit = _ref15.commit;

    var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref16$params = _ref16.params,
        params = _ref16$params === undefined ? {} : _ref16$params,
        _ref16$frontCode = _ref16.frontCode,
        frontCode = _ref16$frontCode === undefined ? '' : _ref16$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.t0 = commit;
              _context8.t1 = LOAD_SYSTEMS;
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].loadSystems, { params: params }, frontCode);

            case 4:
              _context8.t2 = _context8.sent;
              (0, _context8.t0)(_context8.t1, _context8.t2);

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }), _defineProperty(_actions, MODIFY_PWD, function (_ref17) {
    var _this9 = this;

    var commit = _ref17.commit;

    var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref18$data = _ref18.data,
        data = _ref18$data === undefined ? {} : _ref18$data,
        _ref18$frontCode = _ref18.frontCode,
        frontCode = _ref18$frontCode === undefined ? '' : _ref18$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].modifyPwd, { data: data }, frontCode);

            case 2:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  }), _defineProperty(_actions, LOAD_CITYLIST, function (_ref19) {
    var _this10 = this;

    var commit = _ref19.commit;

    var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref20$params = _ref20.params,
        params = _ref20$params === undefined ? {} : _ref20$params,
        _ref20$frontCode = _ref20.frontCode,
        frontCode = _ref20$frontCode === undefined ? '' : _ref20$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.t0 = commit;
              _context10.t1 = LOAD_CITYLIST;
              _context10.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* auth */].loadCitylist, { params: params }, frontCode);

            case 4:
              _context10.t2 = _context10.sent;
              (0, _context10.t0)(_context10.t1, _context10.t2);

            case 6:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }), _defineProperty(_actions, UPDATE_CITYNAME, function (_ref21) {
    var _this11 = this;

    var commit = _ref21.commit;

    var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref22$data = _ref22.data,
        data = _ref22$data === undefined ? {} : _ref22$data,
        _ref22$frontCode = _ref22.frontCode,
        frontCode = _ref22$frontCode === undefined ? '' : _ref22$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit(UPDATE_CITYNAME, data);

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }), _actions),
  /* eslint-disable no-param-reassign */
  mutations: (_mutations = {}, _defineProperty(_mutations, LOGIN, function (state, _ref23) {
    var token = _ref23.token,
        userName = _ref23.userName,
        userId = _ref23.userId;

    state.token = token;
    state.userId = userId;
    state.userName = userName;
  }), _defineProperty(_mutations, REFRESH_TOKEN, function (state) {
    state.token = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token');
  }), _defineProperty(_mutations, LOAD_CODE, function (state, _ref24) {
    var imgUrl = _ref24.imgUrl,
        codeKey = _ref24.codeKey;

    state.codeUrl = imgUrl;
    state.codeKey = codeKey;
  }), _defineProperty(_mutations, LOGOUT, function () {}), _defineProperty(_mutations, LOAD_MENULIST, function (state, data) {
    if (data.length > 0) {
      state.validMenu.value = data;
      data.forEach(function (module) {
        state.validMoudle.push(module.identifyCode);
        if (module.children && module.children.length > 0) {
          module.children.forEach(function (page) {
            state.validPage.push(page.identifyCode);
          });
        }
      });
    }

    function findValidResource(resType, nodes, parentPath) {
      var leafs = [];
      function find(subnodes) {
        subnodes = subnodes || [];
        for (var i = 0; i < subnodes.length; i++) {
          if (subnodes[i].resType === resType) {
            if (!parentPath || parentPath === subnodes[i].resPath) {
              leafs.push(subnodes[i].identifyCode);
            }
          } else if (subnodes[i].children && subnodes[i].children.length > 0) {
            find(subnodes[i].children);
          }
        }
      }
      find(nodes);
      return leafs;
    }
    var validBtns = findValidResource(4, data);
    state.validBtns = validBtns.join(',');

    state.validMenu.loaded = true;
  }), _defineProperty(_mutations, LOAD_SYSTEMS, function (state, data) {
    state.systems.value = data;
    state.systems.loaded = true;
  }), _defineProperty(_mutations, LOAD_CITYLIST, function (state, data) {
    state.cityList = data;
    if (data && data.length != 0) {
      if (window.localStorage.getItem('cityCode')) {
        var obj = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(data, function (o) {
          return o.cityCode == window.localStorage.getItem('cityCode');
        });
        if (!obj) {
          window.localStorage.setItem('cityCode', data[0].cityCode);
          state.curCityName = data[0].cityName;
        } else {
          state.curCityName = obj.cityName;
        }
      } else {
        window.localStorage.setItem('cityCode', data[0].cityCode);
        state.curCityName = data[0].cityName;
      }
    }
  }), _defineProperty(_mutations, UPDATE_CITYNAME, function (state, data) {
    state.curCityName = data.cityName;
  }), _mutations)
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var SAVE_AUTHORITY = 'authApply/SAVE_AUTHORITY';
var INFO_AUTHORITY = 'authApply/INFO_AUTHORITY';
var INFO_AUTHORITY_UNCHECK = 'authApply/INFO_AUTHORITY_UNCHECK';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    detail: {},
    applyList: []
  },
  actions: (_actions = {}, _defineProperty(_actions, SAVE_AUTHORITY, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = SAVE_AUTHORITY;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* authApply */].saveAuthority, { data: data }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_actions, INFO_AUTHORITY, function (_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$params = _ref4.params,
        params = _ref4$params === undefined ? {} : _ref4$params,
        _ref4$frontCode = _ref4.frontCode,
        frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = commit;
              _context2.t1 = INFO_AUTHORITY;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* authApply */].infoAuthority, { params: params }, frontCode);

            case 4:
              _context2.t2 = _context2.sent;
              (0, _context2.t0)(_context2.t1, _context2.t2);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _defineProperty(_actions, INFO_AUTHORITY_UNCHECK, function (_ref5) {
    var _this3 = this;

    var commit = _ref5.commit;

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$params = _ref6.params,
        params = _ref6$params === undefined ? {} : _ref6$params,
        _ref6$frontCode = _ref6.frontCode,
        frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = commit;
              _context3.t1 = INFO_AUTHORITY_UNCHECK;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* authApply */].infoAuthoritUncheck, { params: params }, frontCode);

            case 4:
              _context3.t2 = _context3.sent;
              (0, _context3.t0)(_context3.t1, _context3.t2);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _actions),
  mutations: (_mutations = {}, _defineProperty(_mutations, SAVE_AUTHORITY, function (state, data) {
    state.detail = data;
  }), _defineProperty(_mutations, INFO_AUTHORITY, function (state, data) {
    console.log(data);
    state.applyList = data;
  }), _defineProperty(_mutations, INFO_AUTHORITY_UNCHECK, function (state, data) {
    state.applyList = data;
  }), _mutations)
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_AUTHCONFIGDETAIL = 'authConfig/GET_AUTHCONFIGDETAIL';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        detailData: {}
    },
    actions: _defineProperty({}, GET_AUTHCONFIGDETAIL, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_AUTHCONFIGDETAIL;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["g" /* authConfig */].authConfigDetail, { params: params }, frontCode);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }),
    mutations: _defineProperty({}, GET_AUTHCONFIGDETAIL, function (state, data) {
        state.detailData = data;
    })
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var Query_Permission = 'authQuery/Query_Permission';
var Query_UserList = 'authQuery/Query_UserList';
var GET_UserInfoByUId = 'authQuery/GET_UserInfoByUId';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        tableData: {},
        userInfoData: {},
        userResultList: []
    },
    actions: (_actions = {}, _defineProperty(_actions, Query_Permission, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$data = _ref2.data,
            data = _ref2$data === undefined ? {} : _ref2$data,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = Query_Permission;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["q" /* authQuery */].queryPermission, { data: data }, frontCode);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), _defineProperty(_actions, Query_UserList, function (_ref3) {
        var _this2 = this;

        var commit = _ref3.commit;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$data = _ref4.data,
            data = _ref4$data === undefined ? {} : _ref4$data,
            _ref4$frontCode = _ref4.frontCode,
            frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode,
            _ref4$globalLoading = _ref4.globalLoading,
            globalLoading = _ref4$globalLoading === undefined ? true : _ref4$globalLoading;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.t0 = commit;
                            _context2.t1 = Query_UserList;
                            _context2.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["q" /* authQuery */].queryUserList, { data: data }, frontCode, globalLoading);

                        case 4:
                            _context2.t2 = _context2.sent;
                            (0, _context2.t0)(_context2.t1, _context2.t2);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _defineProperty(_actions, GET_UserInfoByUId, function (_ref5) {
        var _this3 = this;

        var commit = _ref5.commit;

        var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref6$params = _ref6.params,
            params = _ref6$params === undefined ? {} : _ref6$params,
            _ref6$frontCode = _ref6.frontCode,
            frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode,
            _ref6$globalLoading = _ref6.globalLoading,
            globalLoading = _ref6$globalLoading === undefined ? true : _ref6$globalLoading;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.t0 = commit;
                            _context3.t1 = GET_UserInfoByUId;
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* staff */].queryInfoByUId, { params: params }, frontCode, globalLoading);

                        case 4:
                            _context3.t2 = _context3.sent;
                            (0, _context3.t0)(_context3.t1, _context3.t2);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }), _actions),
    mutations: (_mutations = {}, _defineProperty(_mutations, Query_Permission, function (state, data) {
        state.tableData = data;
    }), _defineProperty(_mutations, Query_UserList, function (state, data) {
        state.userResultList = data;
    }), _defineProperty(_mutations, GET_UserInfoByUId, function (state, data) {
        state.userInfoData = data.userInfo;
    }), _mutations)
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_FUNCRESOURCEBYFUNCID = 'configFuntional/GET_FUNCRESOURCEBYFUNCID';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        resListByFuncId: []
    },
    actions: _defineProperty({}, GET_FUNCRESOURCEBYFUNCID, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode,
            _ref2$globalLoading = _ref2.globalLoading,
            globalLoading = _ref2$globalLoading === undefined ? true : _ref2$globalLoading;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_FUNCRESOURCEBYFUNCID;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["j" /* configFuntional */].getResourceListByFuncId, { params: params }, frontCode, globalLoading);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }),
    mutations: _defineProperty({}, GET_FUNCRESOURCEBYFUNCID, function (state, data) {
        state.resListByFuncId = data.resource;
    })
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_DEPARTMENTLIST = 'deptDetail/GET_DEPARTMENTLIST';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        tableData: {}
    },
    actions: _defineProperty({}, GET_DEPARTMENTLIST, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_DEPARTMENTLIST;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["r" /* deptDetail */].getDepartmentList, { params: params }, frontCode);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }),
    mutations: _defineProperty({}, GET_DEPARTMENTLIST, function (state, data) {
        state.tableData = data;
    })
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_ORGTYPEFUNTYPESTATUS = 'functionalManagement/GET_ORGTYPEFUNTYPESTATUS';
var GET_SYSTEMLIST = 'functionalManagement/GET_SYSTEMLIST';
var GET_FUNTLIST = 'functionalManagement/GET_FUNTLIST';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        orgTypeFunTypeStatus: {},
        systemList: [],
        tableData: {}
    },
    actions: (_actions = {}, _defineProperty(_actions, GET_ORGTYPEFUNTYPESTATUS, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_ORGTYPEFUNTYPESTATUS;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["k" /* functionalManagement */].getOrgTypeFunTypeStatus, { params: params }, frontCode, false);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), _defineProperty(_actions, GET_SYSTEMLIST, function (_ref3) {
        var _this2 = this;

        var commit = _ref3.commit;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$params = _ref4.params,
            params = _ref4$params === undefined ? {} : _ref4$params,
            _ref4$frontCode = _ref4.frontCode,
            frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.t0 = commit;
                            _context2.t1 = GET_SYSTEMLIST;
                            _context2.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["k" /* functionalManagement */].getSystemList, { params: params }, frontCode, false);

                        case 4:
                            _context2.t2 = _context2.sent;
                            (0, _context2.t0)(_context2.t1, _context2.t2);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _defineProperty(_actions, GET_FUNTLIST, function (_ref5) {
        var _this3 = this;

        var commit = _ref5.commit;

        var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref6$params = _ref6.params,
            params = _ref6$params === undefined ? {} : _ref6$params,
            _ref6$frontCode = _ref6.frontCode,
            frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.t0 = commit;
                            _context3.t1 = GET_FUNTLIST;
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["k" /* functionalManagement */].getFunList, { params: params }, frontCode, true);

                        case 4:
                            _context3.t2 = _context3.sent;
                            (0, _context3.t0)(_context3.t1, _context3.t2);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }), _actions),
    mutations: (_mutations = {}, _defineProperty(_mutations, GET_ORGTYPEFUNTYPESTATUS, function (state, data) {
        state.orgTypeFunTypeStatus = data;
    }), _defineProperty(_mutations, GET_SYSTEMLIST, function (state, data) {
        state.systemList = data.system;
    }), _defineProperty(_mutations, GET_FUNTLIST, function (state, data) {
        state.tableData = data;
    }), _mutations)
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOGGLE_LOADING = 'global/TOGGLE_LOADING';
var GET_MAINHEIGHT = 'global/GET_MAINHEIGHT';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    mainHeight: ''
  },
  actions: {},
  /* eslint-disable no-param-reassign */
  mutations: (_mutations = {}, _defineProperty(_mutations, TOGGLE_LOADING, function (state, status) {
    switch (status) {
      case 'start':
        state.loading = true;
        break;
      case 'finish':
        state.loading = false;
        break;
      case 'error':
        state.loading = false;
        break;
      default:
    }
  }), _defineProperty(_mutations, GET_MAINHEIGHT, function (state, height) {
    state.mainHeight = height;
  }), _mutations)
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "global", function() { return __WEBPACK_IMPORTED_MODULE_0__global__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resource", function() { return __WEBPACK_IMPORTED_MODULE_2__resource__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resourceDev__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resourceDev", function() { return __WEBPACK_IMPORTED_MODULE_3__resourceDev__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__password__ = __webpack_require__(233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "password", function() { return __WEBPACK_IMPORTED_MODULE_4__password__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__architectureManagement__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "architectureManagement", function() { return __WEBPACK_IMPORTED_MODULE_5__architectureManagement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deptDetail__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deptDetail", function() { return __WEBPACK_IMPORTED_MODULE_6__deptDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__positionDetail__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "positionDetail", function() { return __WEBPACK_IMPORTED_MODULE_7__positionDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__staff__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "staff", function() { return __WEBPACK_IMPORTED_MODULE_8__staff__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__functionalManagement__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "functionalManagement", function() { return __WEBPACK_IMPORTED_MODULE_9__functionalManagement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configFuntional__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "configFuntional", function() { return __WEBPACK_IMPORTED_MODULE_10__configFuntional__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__organizationalManagement__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "organizationalManagement", function() { return __WEBPACK_IMPORTED_MODULE_11__organizationalManagement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__authConfig__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "authConfig", function() { return __WEBPACK_IMPORTED_MODULE_12__authConfig__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resourceDevSync__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resourceDevSync", function() { return __WEBPACK_IMPORTED_MODULE_13__resourceDevSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__authQuery__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "authQuery", function() { return __WEBPACK_IMPORTED_MODULE_14__authQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__authApply__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "authApply", function() { return __WEBPACK_IMPORTED_MODULE_15__authApply__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mineApply__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mineApply", function() { return __WEBPACK_IMPORTED_MODULE_16__mineApply__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__operationLog__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "operationLog", function() { return __WEBPACK_IMPORTED_MODULE_17__operationLog__["a"]; });





































/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var QUERY_AUTHORITY = 'authApply/QUERY_AUTHORITY';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    tableData: [],
    totalRows: 0
  },
  actions: _defineProperty({}, QUERY_AUTHORITY, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = QUERY_AUTHORITY;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["p" /* mineApply */].queryAuthority, { data: data }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }),
  mutations: _defineProperty({}, QUERY_AUTHORITY, function (state, data) {
    state.tableData = data.content;
    state.totalRows = data.totalRows;
  })
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_OPERATIONLOG = 'operationLog/GET_OPERATIONLOG';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    tableData: {}
  },
  actions: _defineProperty({}, GET_OPERATIONLOG, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = GET_OPERATIONLOG;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["o" /* operationLog */].getOperateLog, { data: data }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }),
  mutations: _defineProperty({}, GET_OPERATIONLOG, function (state, data) {
    state.tableData = data;
  })
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_ORGLIST = 'organizationalManagement/GET_ORGLIST';
var GET_CITYLIST = 'organizationalManagement/GET_CITYLIST';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        orgList: [],
        cityList: []
    },
    actions: (_actions = {}, _defineProperty(_actions, GET_ORGLIST, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_ORGLIST;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["i" /* organizationalManagement */].getOrganizationList, { params: params }, frontCode);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), _defineProperty(_actions, GET_CITYLIST, function (_ref3) {
        var _this2 = this;

        var commit = _ref3.commit;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$params = _ref4.params,
            params = _ref4$params === undefined ? {} : _ref4$params,
            _ref4$frontCode = _ref4.frontCode,
            frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.t0 = commit;
                            _context2.t1 = GET_CITYLIST;
                            _context2.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["i" /* organizationalManagement */].getCityList, { params: params }, frontCode);

                        case 4:
                            _context2.t2 = _context2.sent;
                            (0, _context2.t0)(_context2.t1, _context2.t2);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _actions),
    mutations: (_mutations = {}, _defineProperty(_mutations, GET_ORGLIST, function (state, data) {
        state.orgList = data;
    }), _defineProperty(_mutations, GET_CITYLIST, function (state, data) {
        state.cityList = data;
    }), _mutations)
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_CODE = 'password/CODE';
var CHANGE_POSSWORD = 'password/CHANGEPOSSWORD';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  actions: (_actions = {}, _defineProperty(_actions, GET_CODE, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var value;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["s" /* password */].getcode, { params: params }, frontCode, false, true, true);

            case 2:
              value = _context.sent;
              return _context.abrupt('return', value);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_actions, CHANGE_POSSWORD, function (_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$data = _ref4.data,
        data = _ref4$data === undefined ? {} : _ref4$data,
        _ref4$frontCode = _ref4.frontCode,
        frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = commit;
              _context2.t1 = CHANGE_POSSWORD;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["s" /* password */].changepwd, { data: data }, frontCode, true, false, true);

            case 4:
              _context2.t2 = _context2.sent;
              (0, _context2.t0)(_context2.t1, _context2.t2);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _actions),
  /* eslint-disable no-param-reassign */
  mutations: (_mutations = {}, _defineProperty(_mutations, GET_CODE, function () {}), _defineProperty(_mutations, CHANGE_POSSWORD, function () {}), _mutations)
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_POSITIONTLIST = 'positionDetail/GET_POSITIONTLIST';
var GET_STATUSMARKFUNCTIONAL = 'positionDetail/GET_STATUSMARKFUNCTIONAL';
var GET_POSTYPERANK = 'positionDetail/GET_POSTYPERANK';
var GET_FUNCLISTBYDEPT = 'positionDetail/GET_FUNCLISTBYDEPT';

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        tableData: {},
        statusMarkFunctional: {},
        posTypeRank: {},
        funListByDept: [],
        funListByDeptSysType: []
    },
    actions: (_actions = {}, _defineProperty(_actions, GET_POSITIONTLIST, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$frontCode = _ref2.frontCode,
            frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.t0 = commit;
                            _context.t1 = GET_POSITIONTLIST;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* positionDetail */].getPositionList, { params: params }, frontCode);

                        case 4:
                            _context.t2 = _context.sent;
                            (0, _context.t0)(_context.t1, _context.t2);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), _defineProperty(_actions, GET_STATUSMARKFUNCTIONAL, function (_ref3) {
        var _this2 = this;

        var commit = _ref3.commit;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$params = _ref4.params,
            params = _ref4$params === undefined ? {} : _ref4$params,
            _ref4$frontCode = _ref4.frontCode,
            frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.t0 = commit;
                            _context2.t1 = GET_STATUSMARKFUNCTIONAL;
                            _context2.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* positionDetail */].getStatusMarkFunctional, { params: params }, frontCode, false);

                        case 4:
                            _context2.t2 = _context2.sent;
                            (0, _context2.t0)(_context2.t1, _context2.t2);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _defineProperty(_actions, GET_POSTYPERANK, function (_ref5) {
        var _this3 = this;

        var commit = _ref5.commit;

        var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref6$params = _ref6.params,
            params = _ref6$params === undefined ? {} : _ref6$params,
            _ref6$frontCode = _ref6.frontCode,
            frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.t0 = commit;
                            _context3.t1 = GET_POSTYPERANK;
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* positionDetail */].getPosTypeRank, { params: params }, frontCode, false);

                        case 4:
                            _context3.t2 = _context3.sent;
                            (0, _context3.t0)(_context3.t1, _context3.t2);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }), _defineProperty(_actions, GET_FUNCLISTBYDEPT, function (_ref7) {
        var _this4 = this;

        var commit = _ref7.commit;

        var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref8$params = _ref8.params,
            params = _ref8$params === undefined ? {} : _ref8$params,
            _ref8$frontCode = _ref8.frontCode,
            frontCode = _ref8$frontCode === undefined ? '' : _ref8$frontCode;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.t0 = commit;
                            _context4.t1 = GET_FUNCLISTBYDEPT;
                            _context4.t2 = params;
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* positionDetail */].getFunListByDept, { params: params }, frontCode, false);

                        case 5:
                            _context4.t3 = _context4.sent;
                            _context4.t4 = {
                                params: _context4.t2,
                                data: _context4.t3
                            };
                            (0, _context4.t0)(_context4.t1, _context4.t4);

                        case 8:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    }), _actions),
    mutations: (_mutations = {}, _defineProperty(_mutations, GET_POSITIONTLIST, function (state, data) {
        state.tableData = data;
    }), _defineProperty(_mutations, GET_STATUSMARKFUNCTIONAL, function (state, data) {
        state.statusMarkFunctional = data;
    }), _defineProperty(_mutations, GET_POSTYPERANK, function (state, data) {
        state.posTypeRank = data;
    }), _defineProperty(_mutations, GET_FUNCLISTBYDEPT, function (state, payload) {
        if (payload.params.deptId) {
            if (payload.params.types && payload.params.systemId) {
                state.funListByDeptSysType = payload.data.functional;
            } else {
                state.funListByDept = payload.data.functional;
            }
        }
    }), _mutations)
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var LOAD_RESOURCE = 'resource/LOAD_RESOURCE';
var LOAD_ABILITY = 'resource/LOAD_ABILITY';
var EDIT_RESOURCE = 'resource/EDIT_RESOURCE';
var EDIT_ABILITY = 'resource/EDIT_ABILITY';
var TOGGLE_FOLD = 'resource/TOGGLE_FOLD';
var TOGGLE_HIDE = 'resource/TOGGLE_HIDE';
var START_VALID = 'resource/START_VALID';
var STOP_VALID = 'resource/STOP_VALID';
var TOGGLE_VALID = 'resource/TOGGLE_VALID';
var TOGGLE_LOADED = 'resource/TOGGLE_LOADED';
var TOGGLE_REFRESHING = 'resource/TOGGLE_REFRESHING';

function getResourceList(resList, parentValid) {
  var resourceList = [];
  resList.forEach(function (item) {
    var hasChildren = item.resType < 3 && item.children && item.children.length > 0;
    resourceList.push(_extends({}, item, {
      hasChildren: hasChildren,
      isFold: false,
      isHide: false,
      canValid: !!parentValid
    }));
    if (hasChildren && item.resType < 3) {
      resourceList = resourceList.concat(getResourceList(item.children, item.valid));
    }
  });
  return resourceList;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loaded: false,
    refreshing: false,
    activeTab: '',
    systemResources: [],
    funcList: [],
    funcCandidates: [],
    funcValues: []
  },
  actions: (_actions = {}, _defineProperty(_actions, LOAD_RESOURCE, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = LOAD_RESOURCE;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].query, { params: params }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_actions, LOAD_ABILITY, function (_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$params = _ref4.params,
        params = _ref4$params === undefined ? {} : _ref4$params,
        _ref4$frontCode = _ref4.frontCode,
        frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = commit;
              _context2.t1 = LOAD_ABILITY;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].queryAbility, { params: params }, frontCode);

            case 4:
              _context2.t2 = _context2.sent;
              (0, _context2.t0)(_context2.t1, _context2.t2);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _defineProperty(_actions, EDIT_RESOURCE, function (_ref5, _ref6) {
    var _this3 = this;

    var commit = _ref5.commit;
    var _ref6$data = _ref6.data,
        data = _ref6$data === undefined ? {} : _ref6$data,
        $index = _ref6.$index,
        index = _ref6.index,
        _ref6$frontCode = _ref6.frontCode,
        frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = commit;
              _context3.t1 = EDIT_RESOURCE;
              _context3.t2 = index;
              _context3.t3 = $index;
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].orderUpdate, { data: data }, frontCode);

            case 6:
              _context3.t4 = _context3.sent;
              _context3.t5 = {
                index: _context3.t2,
                $index: _context3.t3,
                data: _context3.t4
              };
              (0, _context3.t0)(_context3.t1, _context3.t5);

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _defineProperty(_actions, EDIT_ABILITY, function (_ref7) {
    var _this4 = this;

    var commit = _ref7.commit;

    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref8$data = _ref8.data,
        data = _ref8$data === undefined ? {} : _ref8$data,
        _ref8$frontCode = _ref8.frontCode,
        frontCode = _ref8$frontCode === undefined ? '' : _ref8$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = commit;
              _context4.t1 = EDIT_ABILITY;
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].updateAbility, { data: data }, frontCode);

            case 4:
              _context4.t2 = _context4.sent;
              (0, _context4.t0)(_context4.t1, _context4.t2);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }), _defineProperty(_actions, START_VALID, function (_ref9, _ref10) {
    var _this5 = this;

    var commit = _ref9.commit;
    var _ref10$data = _ref10.data,
        data = _ref10$data === undefined ? {} : _ref10$data,
        $index = _ref10.$index,
        index = _ref10.index,
        resType = _ref10.resType,
        _ref10$frontCode = _ref10.frontCode,
        frontCode = _ref10$frontCode === undefined ? '' : _ref10$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = commit;
              _context5.t1 = TOGGLE_VALID;
              _context5.t2 = index;
              _context5.t3 = $index;
              _context5.t4 = resType;
              _context5.next = 7;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].validRes, {
                data: _extends({}, data, {
                  valid: 1
                })
              }, frontCode);

            case 7:
              _context5.t5 = _context5.sent;
              _context5.t6 = {
                index: _context5.t2,
                $index: _context5.t3,
                resType: _context5.t4,
                data: _context5.t5
              };
              (0, _context5.t0)(_context5.t1, _context5.t6);

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }), _defineProperty(_actions, STOP_VALID, function (_ref11, _ref12) {
    var _this6 = this;

    var commit = _ref11.commit;
    var _ref12$data = _ref12.data,
        data = _ref12$data === undefined ? {} : _ref12$data,
        $index = _ref12.$index,
        index = _ref12.index,
        resType = _ref12.resType,
        _ref12$frontCode = _ref12.frontCode,
        frontCode = _ref12$frontCode === undefined ? '' : _ref12$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = commit;
              _context6.t1 = TOGGLE_VALID;
              _context6.t2 = index;
              _context6.t3 = $index;
              _context6.t4 = resType;
              _context6.next = 7;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].validRes, {
                data: _extends({}, data, {
                  valid: 0
                })
              }, frontCode);

            case 7:
              _context6.t5 = _context6.sent;
              _context6.t6 = {
                index: _context6.t2,
                $index: _context6.t3,
                resType: _context6.t4,
                data: _context6.t5
              };
              (0, _context6.t0)(_context6.t1, _context6.t6);

            case 10:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }), _actions),
  /* eslint-disable no-param-reassign, max-len */
  mutations: (_mutations = {}, _defineProperty(_mutations, LOAD_RESOURCE, function (state, _ref13) {
    var sysList = _ref13.sysList,
        currentSysId = _ref13.currentSysId,
        resList = _ref13.resList;

    if (sysList.length === 0) {
      state.systemResources = [];
    } else {
      var hasChildren = resList && resList.length > 0;
      var systemResources = sysList.map(function (item) {
        return {
          id: item.bizId,
          name: item.resName,
          resourceList: [_extends({}, item, {
            hasChildren: hasChildren,
            canValid: 1
          })]
        };
      });
      for (var i = 0; i < systemResources.length; i++) {
        if (systemResources[i].id === currentSysId) {
          if (hasChildren) {
            systemResources[i].resourceList = systemResources[i].resourceList.concat(getResourceList(resList, systemResources[i].resourceList[0].valid));
          }
          break;
        }
      }
      state.activeTab = currentSysId.toString();
      state.systemResources = systemResources;
    }
  }), _defineProperty(_mutations, LOAD_ABILITY, function (state, data) {
    state.funcList = data;
    state.funcCandidates = data.map(function (item) {
      return item.id;
    });
    state.funcValues = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].valid === 1) {
        state.funcValues.push(data[i].id);
      }
    }
  }), _defineProperty(_mutations, TOGGLE_HIDE, function (state, _ref14) {
    var index = _ref14.index,
        $index = _ref14.$index;

    var targetList = state.systemResources[index].resourceList;
    targetList[$index].isHide = !targetList[$index].isHide;
  }), _defineProperty(_mutations, TOGGLE_FOLD, function (state, _ref15) {
    var index = _ref15.index,
        $index = _ref15.$index;

    var targetList = state.systemResources[index].resourceList;
    targetList[$index].isFold = !targetList[$index].isFold;
  }), _defineProperty(_mutations, EDIT_RESOURCE, function (state, _ref16) {
    var index = _ref16.index,
        $index = _ref16.$index,
        data = _ref16.data;

    var targetList = state.systemResources[index].resourceList;
    targetList.splice($index, 1, _extends({}, targetList[$index], data));
  }), _defineProperty(_mutations, EDIT_ABILITY, function (state) {
    state.funcList = [];
    state.funcValues = [];
  }), _defineProperty(_mutations, TOGGLE_VALID, function (state, _ref17) {
    var index = _ref17.index,
        $index = _ref17.$index,
        resType = _ref17.resType,
        data = _ref17.data;
    var valid = data.valid,
        operatorInfo = data.operatorInfo,
        modifyTime = data.modifyTime;

    var targetList = state.systemResources[index].resourceList;
    var targetResource = targetList[$index];
    switch (resType) {
      case 1:
        for (var i = 1; i < targetList.length; i++) {
          targetList[i].canValid = valid;
          targetList[i].valid = valid;
          targetList[i].operatorInfo = operatorInfo;
          targetList[i].modifyTime = modifyTime;
        }
        break;
      case 2:
        {
          var children = targetResource.children;

          if (children && children.length > 0) {
            for (var _i = $index + 1; _i < $index + 1 + children.length; _i++) {
              targetList[_i].canValid = valid;
              targetList[_i].valid = valid;
              targetList[_i].operatorInfo = operatorInfo;
              targetList[_i].modifyTime = modifyTime;
            }
          }
          break;
        }
      default:
    }
    targetList.splice($index, 1, _extends({}, targetResource, data));
  }), _defineProperty(_mutations, TOGGLE_LOADED, function (state, data) {
    state.loaded = data;
  }), _defineProperty(_mutations, TOGGLE_REFRESHING, function (state, data) {
    state.refreshing = data;
  }), _mutations)
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var LOAD_RESOURCE = 'resourceDev/LOAD_RESOURCE';
var LOAD_BACKURLS = 'resourceDev/LOAD_BACKURLS';
var CREATE_RESOURCE = 'resourceDev/CREATE_RESOURCE';
var EDIT_RESOURCE = 'resourceDev/EDIT_RESOURCE';
var EDIT_DEV = 'resourceDev/EDIT_DEV';
var DELETE_RESOURCE = 'resourceDev/DELETE_RESOURCE';
var TOGGLE_FOLD = 'resourceDev/TOGGLE_FOLD';
var TOGGLE_HIDE = 'resourceDev/TOGGLE_HIDE';
var TOGGLE_LOADED = 'resourceDev/TOGGLE_LOADED';
var TOGGLE_REFRESHING = 'resourceDev/TOGGLE_REFRESHING';

function getResourceList(resList) {
  var resourceList = [];
  resList.forEach(function (item) {
    var hasChildren = item.resType < 4 && item.children && item.children.length > 0;
    resourceList.push(_extends({}, item, {
      hasChildren: hasChildren,
      isFold: false,
      isHide: false
    }));
    if (hasChildren && item.resType < 4) {
      resourceList = resourceList.concat(getResourceList(item.children));
    }
  });
  return resourceList;
}

// 获取子节点下标
function getChildrenIndex(data, parentLevel, parentIndex) {
  var childrenIndex = [];
  for (var i = parentIndex + 1; i < data.length; i++) {
    if (data[i].resType <= parentLevel) {
      break;
    };
    if (data[i].resType - 1 === parentLevel) {
      childrenIndex.push(i);
    }
  }
  var len = childrenIndex.length; // important!!!
  if (len > 0) {
    for (var _i = 0; _i < len; _i++) {
      var childData = data[childrenIndex[_i]];
      if (childData.hasChildren) {
        childrenIndex = childrenIndex.concat(getChildrenIndex(data, childData.resType, childrenIndex[_i]));
      }
    }
  }
  return childrenIndex;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loaded: false,
    refreshing: false,
    activeTab: '',
    systemResources: [],
    backurls: '',
    sync: false,
    runEvn: 'preprod'
  },
  actions: (_actions = {}, _defineProperty(_actions, LOAD_RESOURCE, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = LOAD_RESOURCE;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].query, { params: params }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_actions, LOAD_BACKURLS, function (_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$params = _ref4.params,
        params = _ref4$params === undefined ? {} : _ref4$params,
        _ref4$frontCode = _ref4.frontCode,
        frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = commit;
              _context2.t1 = LOAD_BACKURLS;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].urlQuery, { params: params }, frontCode);

            case 4:
              _context2.t2 = _context2.sent;
              (0, _context2.t0)(_context2.t1, _context2.t2);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _defineProperty(_actions, CREATE_RESOURCE, function (_ref5, _ref6) {
    var _this3 = this;

    var commit = _ref5.commit;
    var _ref6$data = _ref6.data,
        data = _ref6$data === undefined ? {} : _ref6$data,
        index = _ref6.index,
        _ref6$frontCode = _ref6.frontCode,
        frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = commit;
              _context3.t1 = CREATE_RESOURCE;
              _context3.t2 = index;
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].create, { data: data }, frontCode);

            case 5:
              _context3.t3 = _context3.sent;
              _context3.t4 = {
                index: _context3.t2,
                data: _context3.t3
              };
              (0, _context3.t0)(_context3.t1, _context3.t4);

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _defineProperty(_actions, EDIT_RESOURCE, function (_ref7, _ref8) {
    var _this4 = this;

    var commit = _ref7.commit;
    var _ref8$data = _ref8.data,
        data = _ref8$data === undefined ? {} : _ref8$data,
        $index = _ref8.$index,
        index = _ref8.index,
        _ref8$frontCode = _ref8.frontCode,
        frontCode = _ref8$frontCode === undefined ? '' : _ref8$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = commit;
              _context4.t1 = EDIT_RESOURCE;
              _context4.t2 = index;
              _context4.t3 = $index;
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].update, { data: data }, frontCode);

            case 6:
              _context4.t4 = _context4.sent;
              _context4.t5 = {
                index: _context4.t2,
                $index: _context4.t3,
                data: _context4.t4
              };
              (0, _context4.t0)(_context4.t1, _context4.t5);

            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }), _defineProperty(_actions, EDIT_DEV, function (_ref9, _ref10) {
    var _this5 = this;

    var commit = _ref9.commit;
    var _ref10$data = _ref10.data,
        data = _ref10$data === undefined ? {} : _ref10$data,
        $index = _ref10.$index,
        index = _ref10.index,
        _ref10$frontCode = _ref10.frontCode,
        frontCode = _ref10$frontCode === undefined ? '' : _ref10$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = commit;
              _context5.t1 = EDIT_DEV;
              _context5.t2 = index;
              _context5.t3 = $index;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].devUpdate, { data: data }, frontCode);

            case 6:
              _context5.t4 = _context5.sent;
              _context5.t5 = {
                index: _context5.t2,
                $index: _context5.t3,
                data: _context5.t4
              };
              (0, _context5.t0)(_context5.t1, _context5.t5);

            case 9:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }), _defineProperty(_actions, DELETE_RESOURCE, function (_ref11, _ref12) {
    var _this6 = this;

    var commit = _ref11.commit;
    var _ref12$data = _ref12.data,
        data = _ref12$data === undefined ? {} : _ref12$data,
        children = _ref12.children,
        resType = _ref12.resType,
        parentId = _ref12.parentId,
        $index = _ref12.$index,
        index = _ref12.index,
        _ref12$frontCode = _ref12.frontCode,
        frontCode = _ref12$frontCode === undefined ? '' : _ref12$frontCode;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var resId;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              resId = data.resId;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].post(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* resource */].delete, { data: data }, frontCode);

            case 3:
              commit(DELETE_RESOURCE, {
                index: index,
                $index: $index,
                resId: resId,
                parentId: parentId,
                resType: resType,
                children: children
              });

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }), _actions),
  /* eslint-disable no-param-reassign, max-len */
  mutations: (_mutations = {}, _defineProperty(_mutations, LOAD_RESOURCE, function (state, _ref13) {
    var sysList = _ref13.sysList,
        currentSysId = _ref13.currentSysId,
        resList = _ref13.resList,
        sync = _ref13.sync,
        runEvn = _ref13.runEvn;

    if (sysList.length === 0) {
      state.systemResources = [];
    } else {
      var hasChildren = resList && resList.length > 0;
      var systemResources = sysList.map(function (item) {
        return {
          id: item.bizId,
          name: item.resName,
          resourceList: [_extends({}, item, {
            hasChildren: hasChildren
          })]
        };
      });
      for (var i = 0; i < systemResources.length; i++) {
        if (systemResources[i].id === currentSysId) {
          if (hasChildren) {
            systemResources[i].resourceList = systemResources[i].resourceList.concat(getResourceList(resList));
          }
          break;
        }
      }
      state.activeTab = currentSysId.toString();
      state.systemResources = systemResources;
      state.sync = sync || false;
      state.runEvn = runEvn || 'preprod';
    }
  }), _defineProperty(_mutations, LOAD_BACKURLS, function (state, data) {
    state.backurls = data;
  }), _defineProperty(_mutations, CREATE_RESOURCE, function (state, _ref14) {
    var $index = _ref14.index,
        data = _ref14.data;
    var id = data.id,
        bizId = data.bizId,
        parentResId = data.parentResId,
        resName = data.resName,
        resType = data.resType;

    var resourceList = $index !== '' ? state.systemResources[$index].resourceList : '';
    if (resType === 1) {
      state.systemResources.push({
        id: bizId,
        name: resName,
        resourceList: [_extends({}, data, {
          hasChildren: false,
          isFold: false
        })]
      });
      state.activeTab = bizId.toString();
    } else if (resType === 2) {
      if (resourceList.length === 1) {
        resourceList[0].hasChildren = true;
      }
      resourceList.push(_extends({}, data, {
        hasChildren: false,
        isFold: false
      }));
    } else {
      var index = void 0;
      for (var i = 0; i < resourceList.length; i++) {
        if (resourceList[i].bizId === parentResId) {
          if (!resourceList[i].children) {
            resourceList[i].children = [];
            resourceList[i].hasChildren = true;
          }
          resourceList[i].children.push(data);
          index = i;
          break;
        }
      }
      var num = 1;
      if (index) {
        num += index;
      }
      resourceList.splice(num, 0, _extends({}, data, {
        hasChildren: false,
        isFold: false,
        isHide: resourceList[index].isFold
      }));
    }
  }), _defineProperty(_mutations, DELETE_RESOURCE, function (state, _ref15) {
    var index = _ref15.index,
        $index = _ref15.$index,
        resId = _ref15.resId,
        parentId = _ref15.parentId,
        resType = _ref15.resType,
        children = _ref15.children;

    var targetList = state.systemResources[index].resourceList;
    if (children && children.length > 0) {
      var childrenIndex = getChildrenIndex(targetList, resType, $index);
      targetList.splice($index + 1, childrenIndex.length);
    }
    targetList.splice($index, 1);
    if (resType !== 2) {
      var parentResource = {};
      for (var i = 0; i < targetList.length; i++) {
        if (targetList[i].id === parentId) {
          parentResource = targetList[i];
          break;
        }
      }
      var parentChildren = [];
      if (parentResource.children) {
        parentChildren = parentResource.children;
      }
      for (var _i2 = 0; _i2 < parentChildren.length; _i2++) {
        if (parentChildren[_i2].id === resId) {
          parentChildren.splice(_i2, 1);
          if (parentChildren.length === 0) {
            parentResource.isFold = false;
            parentResource.hasChildren = false;
          }
          break;
        }
      }
    } else if (targetList.length === 1) {
      targetList[0].hasChildren = false;
      targetList[0].isFold = false;
    }
  }), _defineProperty(_mutations, TOGGLE_HIDE, function (state, _ref16) {
    var index = _ref16.index,
        $index = _ref16.$index;

    var targetList = state.systemResources[index].resourceList;
    targetList[$index].isHide = !targetList[$index].isHide;
  }), _defineProperty(_mutations, TOGGLE_FOLD, function (state, _ref17) {
    var index = _ref17.index,
        $index = _ref17.$index;

    var targetList = state.systemResources[index].resourceList;
    targetList[$index].isFold = !targetList[$index].isFold;
  }), _defineProperty(_mutations, EDIT_RESOURCE, function (state, _ref18) {
    var index = _ref18.index,
        $index = _ref18.$index,
        data = _ref18.data;

    var targetList = state.systemResources[index].resourceList;
    targetList.splice($index, 1, _extends({}, targetList[$index], data));
    if ($index === 0) {
      state.systemResources[index].name = data.resName;
    }
  }), _defineProperty(_mutations, EDIT_DEV, function (state, _ref19) {
    var index = _ref19.index,
        $index = _ref19.$index,
        data = _ref19.data;

    var targetList = state.systemResources[index].resourceList;
    targetList.splice($index, 1, _extends({}, targetList[$index], data));
  }), _defineProperty(_mutations, TOGGLE_LOADED, function (state, data) {
    state.loaded = data;
  }), _defineProperty(_mutations, TOGGLE_REFRESHING, function (state, data) {
    state.refreshing = data;
  }), _mutations)
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var LOAD_SYSRESOURCE = 'resourceDevSync/LOAD_SYSRESOURCE';
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    systemResData: {}
  },
  actions: _defineProperty({}, LOAD_SYSRESOURCE, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = LOAD_SYSRESOURCE;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["m" /* resourceDevSync */].query, { params: params }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }),
  mutations: _defineProperty({}, LOAD_SYSRESOURCE, function (state, data) {
    state.systemResData = data;
  })
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_STAFFLIST = "staff/GET_STAFFLIST";
var GET_DEPTANDORG = "staff/GET_DEPTANDORG";
var GET_FUNDOWNER = "staff/GET_FUNDOWNER";

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    tableData: {},
    deptAndOrg: [],
    fundOwnerOptions: [],
    statusCount: [{ status: 0, statusStr: "待开通", count: 0 }, { status: 1, statusStr: "待调整", count: 0 }, { status: 2, statusStr: "已处理", count: 0 }, { status: 3, statusStr: "全部", count: 0 }]
  },
  actions: (_actions = {}, _defineProperty(_actions, GET_STAFFLIST, function (_ref) {
    var _this = this;

    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$frontCode = _ref2.frontCode,
        frontCode = _ref2$frontCode === undefined ? '' : _ref2$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.t1 = GET_STAFFLIST;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* staff */].queryStaffList, { params: params }, frontCode);

            case 4:
              _context.t2 = _context.sent;
              (0, _context.t0)(_context.t1, _context.t2);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), _defineProperty(_actions, GET_DEPTANDORG, function (_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$params = _ref4.params,
        params = _ref4$params === undefined ? {} : _ref4$params,
        _ref4$frontCode = _ref4.frontCode,
        frontCode = _ref4$frontCode === undefined ? '' : _ref4$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = commit;
              _context2.t1 = GET_DEPTANDORG;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* staff */].querydeptAndOrg, { params: params }, frontCode);

            case 4:
              _context2.t2 = _context2.sent;
              (0, _context2.t0)(_context2.t1, _context2.t2);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), _defineProperty(_actions, GET_FUNDOWNER, function (_ref5) {
    var _this3 = this;

    var commit = _ref5.commit;

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$params = _ref6.params,
        params = _ref6$params === undefined ? {} : _ref6$params,
        _ref6$frontCode = _ref6.frontCode,
        frontCode = _ref6$frontCode === undefined ? '' : _ref6$frontCode;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = commit;
              _context3.t1 = GET_FUNDOWNER;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Client */].get(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* staff */].queryFundOwner, { params: params }, frontCode);

            case 4:
              _context3.t2 = _context3.sent;
              (0, _context3.t0)(_context3.t1, _context3.t2);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _actions),
  mutations: (_mutations = {}, _defineProperty(_mutations, GET_STAFFLIST, function (state, data) {
    state.tableData = data.pageUser;
    state.statusCount = data.statusCount;
  }), _defineProperty(_mutations, GET_DEPTANDORG, function (state, data) {
    state.deptAndOrg = data;
  }), _defineProperty(_mutations, GET_FUNDOWNER, function (state, data) {
    state.fundOwnerOptions = data;
  }), _mutations)
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









// const axios = axios.create();

// axios.defaults.withCredentials = true;

// 要求更新完token再请求，请使用此延迟函数
/* eslint-disable no-param-reassign */
// function debounce(method, delay) {
//   clearTimeout(method.tId);
//   method.resolveTasks = method.resolveTasks || [];
//   method.rejectTasks = method.rejectTasks || [];
//   return new Promise((resolve, reject) => {
//     method.resolveTasks.push(resolve);
//     method.rejectTasks.push(reject);
//     method.tId = setTimeout(() => method().then(() => {
//       method.resolveTasks.forEach(item => item());
//       method.resolveTasks = [];
//       method.rejectTasks = [];
//     }, (err) => {
//       method.rejectTasks.forEach(item => item(err));
//       method.resolveTasks = [];
//       method.rejectTasks = [];
//     }), delay);
//   });
// }

function tokenErr() {
  //MessageBox.close();
  __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove('token', { domain: '.izhikang.com' });
  __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove('tokenExpireTime', { domain: '.izhikang.com' });
  __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove('userName', { domain: '.izhikang.com' });
  __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove('userId', { domain: '.izhikang.com' });
  __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a.closeAll();
  // Message.error({
  //   content: '登录信息已过期或无效，请重新登录',
  //   duration: 10,
  //   closable: true,
  // });
  __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
    name: 'login',
    query: { target: encodeURIComponent(window.location.href) }
  });
}

function refreshToken() {
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'start');
  var refresh = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create();
  refresh.defaults.headers.common.token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token');
  refresh({
    method: 'post',
    url: __WEBPACK_IMPORTED_MODULE_4__api__["b" /* auth */].refreshToken,
    withCredentials: true
  }).then(function (response) {
    if (response.data.ret === true) {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('auth/REFRESH_TOKEN');
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'finish');
    } else {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'error');
      // 若token解析失败，已过期 则返回登录页，清除已过期token
      if (response.data.errcode === -11001) {
        tokenErr();
      } else {
        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a.closeAll();
        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
          message: response.data.msg,
          type: 'error',
          duration: 6000,
          customClass: 'messageZIndex'
        });
      }
    }
  }).catch(function () {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'error');
    __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a.closeAll();
    __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
      message: '服务器开小差了',
      duration: 6000,
      type: 'error',
      customClass: 'messageZIndex'
    });
  });
}

var methods = ['get', 'post', 'delete', 'put'];

var Client = function Client() {
  var _this = this;

  _classCallCheck(this, Client);

  methods.forEach(function (method) {
    _this[method] = function (url) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$params = _ref.params,
          params = _ref$params === undefined ? {} : _ref$params,
          _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data,
          headers = _ref.headers;

      var frontCode = arguments[2];
      var globalLoading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var returnErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var needReturnRes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      if (__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute.name !== 'login') {
        var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token');
        var tokenExpireTime = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('tokenExpireTime');
        if (token && tokenExpireTime) {
          var now = new Date().getTime();
          if (now > tokenExpireTime - 10 * 60 * 1000 && now < tokenExpireTime) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* debounce */])(refreshToken, 500);
          } else if (now > tokenExpireTime) {
            tokenErr();
            return Promise.reject();
          }
        }
      }
      return new Promise(function (resolve, reject) {
        if (globalLoading) {
          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'start');
        }
        var request = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
          baseURL: "", // url = base url + request url
          withCredentials: true,
          timeout: 50000 // request timeout
        });
        var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token');
        if (!frontCode) {
          var notFrontCode = ['login', 'guide', 'not-found'].indexOf(__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute.name) > -1;
          frontCode = notFrontCode ? '' : __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute.name; // eslint-disable-line no-param-reassign
        }
        if (frontCode && frontCode !== 'NOT') {
          request.defaults.headers.common.frontCode = frontCode;
        }
        if (token) {
          request.defaults.headers.common.token = token;
        }
        request.defaults.headers.common.sysCode = 'izk-authservice';
        // request.defaults.headers.common.timestamp = new Date().valueOf();
        request({
          headers: _extends({
            timestamp: Date.now().valueOf(),
            cityCode: window.localStorage.getItem('cityCode') ? window.localStorage.getItem('cityCode') : '010'
          }, headers),
          method: method,
          url: url,
          params: method === 'get' ? _extends({}, params, {
            _: new Date().getTime()
          }) : '',
          data: data
        }).then(function (response) {
          if (response.data.ret === true) {
            if (response.data.data && response.data.data.needMsg) {
              __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
                message: response.data.msg,
                duration: 6000,
                type: 'warning',
                customClass: 'messageZIndex'
              });
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'finish');
            if (needReturnRes) {
              return resolve(response.data);
            }
            return resolve(response.data.data);
          }
          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'error');

          // 若token解析失败，已过期 则返回登录页，清除已过期token
          if (response.data.errcode === -11001) {
            tokenErr();
            return;
          } else if (response.data.errcode === 400408) {
            __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message_box___default()({
              title: '提示',
              message: response.data.msg,
              confirmButtonText: '修改密码',
              type: 'error'
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                path: '/changepwd',
                query: {
                  tel: response.data.data
                }
              });
            }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
              message: response.data.msg,
              type: 'error',
              duration: 6000,
              customClass: 'messageZIndex'
            });
            if (returnErr) {
              return reject(response.data);
            } else {
              return;
            }
          }
          return resolve(response.data);
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('global/TOGGLE_LOADING', 'error');
          __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a.closeAll();
          __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default()({
            message: '服务器开小差了',
            duration: 6000,
            type: 'error',
            customClass: 'messageZIndex'
          });
          //return reject(err);
        });
      });
    };
  });
};

/* harmony default export */ __webpack_exports__["a"] = (new Client());

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-param-reassign */
/* harmony default export */ __webpack_exports__["a"] = (function (method, delay) {
  clearTimeout(method.tId);
  method.tId = setTimeout(function () {
    return method();
  }, delay);
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//部门机构列表数据结构修改为联动数据格式
var deptListToCascader = function deptListToCascader(list) {
    if (list && list.length > 0) {
        return deptListGenChild(list);
    } else {
        return [];
    }
};
var deptListGenChild = function deptListGenChild(list) {
    var arr = [];
    list.forEach(function (item) {
        var itemObj = {};

        itemObj.label = item.deptName;
        itemObj.value = item.bizId;

        if (item.children && item.children.length > 0) {
            itemObj.children = deptListGenChild(item.children);
        }

        arr.push(itemObj);
    });
    return arr;
};

/* harmony default export */ __webpack_exports__["a"] = (deptListToCascader);

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160);
module.exports = __webpack_require__(159);


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules__ = __webpack_require__(229);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var RESET = 'root/RESET';
var initializeState = {};

/* eslint no-restricted-syntax: 0 */
for (var key in __WEBPACK_IMPORTED_MODULE_2__modules__) {
  if (Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_2__modules__, key)) {
    initializeState[key] = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_2__modules__[key].state));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  /* eslint-disable no-param-reassign */
  mutations: _defineProperty({}, RESET, function (state) {
    for (var _key in initializeState) {
      if (Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_2__modules__, _key)) {
        state[_key] = JSON.parse(JSON.stringify(initializeState[_key]));
      }
    }
  }),
  modules: __WEBPACK_IMPORTED_MODULE_2__modules__,
  strict: "production" !== 'production'
}));

/***/ })

},[481]);


// WEBPACK FOOTER //
// static/js/app.718683c17be4d03b7030.js